var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1366 378",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(0.340000, 0.760000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_3"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#2B2B2B",
    cx: 90,
    cy: 287.04,
    r: 90
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#2B2B2B",
    cx: 287.1,
    cy: 287.04,
    r: 90
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#2B2B2B",
    cx: 484.2,
    cy: 287.04,
    r: 90
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#2B2B2B",
    cx: 682.3,
    cy: 287.04,
    r: 90
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#2B2B2B",
    cx: 879.4,
    cy: 287.04,
    r: 90
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#2B2B2B",
    cx: 1077.5,
    cy: 287.04,
    r: 90
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#2B2B2B",
    cx: 1275.6,
    cy: 287.04,
    r: 90
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(197.100000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90,0 C139.71,0 180,40.29 180,90 C180,139.71 139.71,180 90,180 C40.29,180 0,139.71 0,90 C0,40.29 40.29,0 90,0 Z M119.19,90 C119.19,73.88 106.12,60.81 90,60.81 C73.88,60.81 60.81,73.88 60.81,90 C60.81,106.12 73.88,119.19 90,119.19 C106.12,119.19 119.19,106.12 119.19,90 Z",
    id: "Shape",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 90,
    cy: 90,
    r: 29.19
  })), /*#__PURE__*/React.createElement("path", {
    d: "M153.64,153.64 C137.35,169.93 114.85,180 90,180 C40.29,180 0,139.71 0,90 C0,40.29 40.29,0 90,0 C114.85,0 137.35,10.07 153.64,26.36 L110.64,69.36 C105.36,64.08 98.06,60.81 90,60.81 C73.88,60.81 60.81,73.88 60.81,90 C60.81,106.12 73.88,119.19 90,119.19 C98.06,119.19 105.36,115.92 110.64,110.64 L153.64,153.64 Z",
    id: "Path",
    fill: "#2B2B2B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    transform: "translate(41.320000, 228.160000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1008.71,27.19 L1025.27,27.19 L1025.27,33.95 C1029.03,30.78 1032.43,28.58 1035.48,27.34 C1038.53,26.1 1041.65,25.48 1044.84,25.48 C1051.38,25.48 1056.94,27.77 1061.5,32.34 C1065.34,36.22 1067.26,41.97 1067.26,49.57 L1067.26,93.2 L1050.88,93.2 L1050.88,64.29 C1050.88,56.41 1050.53,51.18 1049.82,48.59 C1049.11,46 1047.88,44.03 1046.13,42.68 C1044.38,41.33 1042.21,40.65 1039.62,40.65 C1036.27,40.65 1033.4,41.77 1030.99,44.01 C1028.59,46.25 1026.92,49.35 1026,53.31 C1025.52,55.37 1025.27,59.84 1025.27,66.7 L1025.27,93.18 L1008.71,93.18 L1008.71,27.19 L1008.71,27.19 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.66,27.19 L1268.16,27.19 L1268.16,83.74 C1268.16,94.9 1265.91,103.12 1261.42,108.37 C1255.39,115.49 1246.31,119.05 1234.18,119.05 C1227.71,119.05 1222.27,118.24 1217.86,116.62 C1213.45,115 1209.73,112.62 1206.69,109.49 C1203.66,106.35 1201.41,102.54 1199.96,98.05 L1218.22,98.05 C1219.84,99.91 1221.92,101.32 1224.47,102.27 C1227.02,103.22 1230.03,103.7 1233.51,103.7 C1237.96,103.7 1241.54,103.01 1244.25,101.64 C1246.96,100.26 1248.87,98.48 1249.98,96.3 C1251.09,94.12 1251.65,90.35 1251.65,85.01 C1248.74,87.92 1245.68,90.01 1242.49,91.29 C1239.29,92.56 1235.67,93.2 1231.63,93.2 C1222.77,93.2 1215.29,90.01 1209.18,83.61 C1203.07,77.22 1200.02,69.13 1200.02,59.34 C1200.02,48.86 1203.26,40.45 1209.73,34.1 C1215.59,28.36 1222.59,25.48 1230.72,25.48 C1234.52,25.48 1238.11,26.18 1241.49,27.57 C1244.87,28.96 1248.25,31.26 1251.65,34.46 L1251.65,27.19 L1251.66,27.19 Z M1234.49,40.96 C1229.27,40.96 1224.96,42.71 1221.57,46.21 C1218.17,49.71 1216.47,54.11 1216.47,59.41 C1216.47,64.91 1218.21,69.42 1221.69,72.94 C1225.17,76.46 1229.54,78.22 1234.8,78.22 C1239.94,78.22 1244.18,76.5 1247.51,73.06 C1250.84,69.62 1252.52,65.11 1252.52,59.53 C1252.52,54.03 1250.84,49.56 1247.48,46.12 C1244.11,42.68 1239.78,40.96 1234.49,40.96 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M839.85,0 C842.75,0 845.24,1.05 847.32,3.16 C849.4,5.26 850.44,7.81 850.44,10.81 C850.44,13.76 849.41,16.28 847.35,18.36 C845.29,20.44 842.83,21.49 839.97,21.49 C837.03,21.49 834.51,20.43 832.44,18.3 C830.36,16.18 829.32,13.6 829.32,10.56 C829.32,7.65 830.35,5.16 832.4,3.1 C834.47,1.03 836.95,0 839.85,0 Z M831.57,27.19 L848.13,27.19 L848.13,93.2 L831.57,93.2 L831.57,27.19 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "618.71 1.7 635.27 1.7 635.27 54.4 659.66 27.18 680.46 27.18 652.02 58.82 683.86 93.2 663.3 93.2 635.27 62.78 635.27 93.2 618.71 93.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.79,27.43 L443.99,27.43 L443.99,35.74 C445.53,32.46 447.57,29.98 450.12,28.28 C452.67,26.58 455.46,25.73 458.49,25.73 C460.63,25.73 462.88,26.3 465.22,27.43 L460.06,41.69 C458.12,40.72 456.52,40.23 455.27,40.23 C452.72,40.23 450.57,41.81 448.81,44.96 C447.05,48.11 446.17,54.3 446.17,63.53 L446.23,66.74 L446.23,93.44 L429.79,93.44 L429.79,27.43 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.4,23.93 C252.63,23.93 258.48,25.49 263.97,28.6 C269.45,31.72 273.73,35.94 276.8,41.28 C279.87,46.62 281.41,52.38 281.41,58.57 C281.41,64.8 279.86,70.62 276.77,76.04 C273.68,81.46 269.46,85.7 264.12,88.75 C258.78,91.8 252.9,93.33 246.46,93.33 C236.99,93.33 228.91,89.96 222.22,83.23 C215.52,76.5 212.18,68.31 212.18,58.69 C212.18,48.38 215.96,39.78 223.53,32.9 C230.16,26.92 237.78,23.93 246.4,23.93 Z M246.67,39.52 C241.52,39.52 237.24,41.31 233.82,44.89 C230.4,48.47 228.68,53.05 228.68,58.63 C228.68,64.37 230.37,69.03 233.75,72.59 C237.13,76.15 241.42,77.93 246.6,77.93 C251.79,77.93 256.1,76.13 259.55,72.53 C262.99,68.93 264.72,64.3 264.72,58.64 C264.72,52.98 263.03,48.38 259.65,44.84 C256.26,41.29 251.94,39.52 246.67,39.52 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "2.84217094e-14 27.3 16.21 27.3 29.48 64.86 43.76 27.3 53.68 27.3 67.71 64.43 81 27.3 97.32 27.3 73.23 93.32 62.73 93.32 48.65 55.7 34.15 93.32 23.77 93.32"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c8132d966c60d2efc25387f4d0be0b59.svg";
export { ForwardRef as ReactComponent };